import { render, staticRenderFns } from "./ConsentSpecimenCollection.vue?vue&type=template&id=7953e746"
import script from "./ConsentSpecimenCollection.vue?vue&type=script&lang=js"
export * from "./ConsentSpecimenCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports